import { useCallback, useMemo } from 'react';
import { getContentsSorts, getResourcesSorts } from 'utils';

const mapFeatureToSorts = (feature, sortType) => {
  const allSorts = {
    resources: getResourcesSorts(sortType),
    contents: getContentsSorts(sortType),
  };

  return allSorts[feature];
};

export default function useSort({ feature = 'contents', sortType } = {}) {
  const memoizedFeatureToSorts = useMemo(
    () => mapFeatureToSorts(feature, sortType),
    [feature, sortType]
  );

  const getSorts = useCallback(
    (platform) => memoizedFeatureToSorts[platform],
    [memoizedFeatureToSorts]
  );

  return {
    getSorts,
  };
}
